import React from 'react'
import Masonry from 'react-masonry-component'
import { Box } from '@mui/material'
import { Loader } from 'packages/eid-ui'
import { useTranslation } from 'react-i18next'

const masonryOptions = {
    transitionDuration: 0,
    horizontalOrder: true,
}

const EidCardList = ({
    data,
    isLoading,
    LoadingIndicatorComponent = Loader,
    isLoadingMore,
    noDataMessage = '',
    attributes,
    pagination,
    CardComponent,
    onClickDetailButton,
    renderLeftButton,
    renderRightButton,
}) => {
    const { t } = useTranslation()
    if (!data || isLoading)
        return <LoadingIndicatorComponent attributes={attributes} />
    if (data?.length === 0)
        return (
            <Box
                width="100%"
                height="100%"
                display="flex"
                justifyContent="center"
                paddingY="20px"
            >
                {noDataMessage || t('NoDataMessage')}
            </Box>
        )
    return (
        <>
            <Masonry
                options={masonryOptions}
                style={{ marginLeft: '-1.4rem', marginRight: '-2.4rem' }}
                enableResizableChildren
            >
                {data.map((item, index) => (
                    <CardComponent
                        key={index}
                        item={item}
                        attributes={attributes}
                        onClickDetailButton={onClickDetailButton}
                        renderLeftButton={renderLeftButton}
                        renderRightButton={renderRightButton}
                    />
                ))}
            </Masonry>
            <Box
                style={{
                    display: 'flex',
                    justifyContent: 'center',
                    marginTop: '40px',
                }}
            >
                <Box>{pagination}</Box>
            </Box>
            {isLoadingMore && <Loader height="1in" width="100%" />}
        </>
    )
}

export default EidCardList
